import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { SparklesIcon, HeartIcon } from 'lucide-react';
export function FutureRoadmap() {
  const {
    t
  } = useLanguage();
  const items = [{
    icon: SparklesIcon,
    title: t('roadmap.coach.title'),
    description: t('roadmap.coach.description'),
    status: t('roadmap.coach.status')
  }, {
    icon: HeartIcon,
    title: t('roadmap.fund.title'),
    description: t('roadmap.fund.description'),
    status: t('roadmap.fund.status')
  }];
  return <section className="w-full py-32 px-6 bg-white border-t-2 border-black" data-id="element-227">
      <div className="max-w-5xl mx-auto" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-229">
          <div className="inline-block px-4 py-1 border border-black text-xs font-mono tracking-wider uppercase mb-6" data-id="element-230">
            {t('roadmap.badge')}
          </div>
          <h2 className="text-5xl md:text-7xl font-black text-black mb-6 uppercase tracking-tighter leading-none" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontStretch: 'condensed'
        }} data-id="element-231">
            {t('roadmap.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-232">
            {t('roadmap.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-233">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="border-2 border-black p-8 bg-white hover:bg-black hover:text-white transition-colors duration-300 group" data-id="element-234">
                <div className="flex items-start justify-between mb-6" data-id="element-235">
                  <Icon className="w-8 h-8" strokeWidth={1.5} data-id="element-236" />
                  <span className="text-xs font-mono uppercase tracking-wider px-3 py-1 border border-current opacity-70" data-id="element-237">
                    {item.status}
                  </span>
                </div>
                <h3 className="text-2xl md:text-3xl font-black mb-3 uppercase tracking-tight" data-id="element-238">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed opacity-80" data-id="element-239">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center text-sm font-bold uppercase tracking-widest text-black" data-id="element-240">
          {t('roadmap.note')}
        </motion.p>
      </div>
    </section>;
}